import script from "./LoaderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderModal.vue?vue&type=script&setup=true&lang=js"

import "./LoaderModal.vue?vue&type=style&index=0&id=6cb128f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb128f3"]])

export default __exports__